<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="12">
            <h4 id="traffic" class="card-title mb-0">Log de Notificaciones</h4>
            <div class="small text-muted">Historial de todos los envíos reales, de todos los canales (interna, email, SMS, whatsapp, push)</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-alert variant="info" :show="!!filter.reference" class="d-flex justify-content-between align-items-center">
          <span>Mostrando solo las notificaciones de <strong>{{ filter.reference }}</strong></span>
          <b-button size="sm" variant="outline-info" @click="clearReferenceFilter()">Quitar filtro</b-button>
        </b-alert>

        <b-row class="mb-3">
          <b-col md="3">
            <b-form-group label="Fecha">
              <b-row>
                <b-col md="6" class="pr-0">
                  <b-form-input type="date" v-model="filter.date_start" placeholder="Desde"></b-form-input>
                </b-col>
                <b-col md="6" class="pl-0">
                  <b-form-input type="date" v-model="filter.date_end" placeholder="Hasta"></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Canal">
              <b-form-select v-model="filter.channel" :options="arr.select.channels"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Módulo">
              <b-form-select v-model="filter.module_id" :options="moduleOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Estado">
              <b-form-select v-model="filter.status" :options="arr.select.status"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="1" class="d-flex align-items-end">
            <b-button variant="outline-dark" @click="search()" class="mb-3">
              <b-icon icon="filter"></b-icon>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-table class="mb-0 notifications-log-table"
                  responsive="sm"
                  head-variant="dark"
                  :hover="true"
                  :items="table.items"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  v-if="table.items.length">

              <template v-slot:cell(date_time)="data">
                {{ formatDate(data.item.date_time) }}
              </template>

              <template v-slot:cell(channel)="data">
                <b-badge :variant="channelVariant(data.item.channel)">
                  {{ channelLabel(data.item.channel) }}
                </b-badge>
              </template>

              <template v-slot:cell(process)="data">
                <strong v-if="data.item.module">{{ moduleLabel(data.item.module) }}</strong>
                <span class="text-muted" v-else>Sistema</span>
                <div class="text-muted" v-if="data.item.reference">{{ data.item.reference }}</div>
              </template>

              <template v-slot:cell(to)="data">
                {{ data.item.to || '-' }}
              </template>

              <template v-slot:cell(description)="data">
                <div v-if="data.item.description">
                  <div class="log-description"
                       :class="{ 'log-description-collapsed': isLongDescription(data.item.description) && !data.item._showFullDescription }">{{ data.item.description }}</div>
                  <b-link v-if="isLongDescription(data.item.description)"
                          class="log-description-toggle"
                          @click="toggleDescription(data.item)">
                    {{ data.item._showFullDescription ? 'Ver menos' : 'Ver mensaje completo' }}
                  </b-link>
                </div>
                <span v-else>-</span>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge variant="success" v-if="data.item.status" v-b-tooltip.hover title="Enviado correctamente">
                  <b-icon icon="check-circle-fill" class="mr-1"></b-icon>Éxito
                </b-badge>
                <b-badge variant="danger" v-else v-b-tooltip.hover :title="data.item.error || 'Falló el envío'">
                  <b-icon icon="x-circle-fill" class="mr-1"></b-icon>Error
                </b-badge>
              </template>

              <template v-slot:cell(delivery_status)="data">
                <b-badge v-if="data.item.delivery_status" :variant="deliveryStatusVariant(data.item.delivery_status)" v-b-tooltip.hover :title="data.item.error || ''">
                  {{ deliveryStatusLabel(data.item.delivery_status) }}
                </b-badge>
                <span class="text-muted" v-else-if="data.item.channel == 'whatsapp' && data.item.status" v-b-tooltip.hover title="Todavía no llegó la confirmación de entrega de Meta">
                  Pendiente
                </span>
                <span class="text-muted" v-else>-</span>
              </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron notificaciones con esos filtros</b-alert>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>

          <b-col v-if="table.items.length">
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.items.length"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Storage from '@/handler/storageLocal'
  import moment from 'moment'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'log',
          elements: {}
        },
        table: {
          items: [],
          currentPage: 1,
          perPage: 50,
          fields: [
            {key: 'date_time', label: 'Fecha', class: "align-middle text-left"},
            {key: 'channel', label: 'Canal', class: "align-middle text-left"},
            {key: 'process', label: 'Proceso', class: "align-middle"},
            {key: 'to', label: 'Destinatario', class: "align-middle text-left"},
            {key: 'description', label: 'Mensaje', class: "align-middle text-left"},
            {key: 'status', label: 'Estado', class: "align-middle text-center"},
            {key: 'delivery_status', label: 'Entrega', class: "align-middle text-center"},
          ],
        },
        filter: {
          date_start: '',
          date_end: '',
          channel: '',
          module_id: '',
          status: '',
          reference: '',
        },
        arr: {
          select: {
            channels: [
              { value: '', text: 'TODOS' },
              { value: 'internal', text: 'Interna' },
              { value: 'email', text: 'Email' },
              { value: 'sms', text: 'SMS' },
              { value: 'whatsapp', text: 'WhatsApp' },
              { value: 'push', text: 'Push' },
            ],
            status: [
              { value: '', text: 'TODOS' },
              { value: '1', text: 'Éxito' },
              { value: '0', text: 'Error' },
            ],
          }
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.restoreFilterStorage()

      if (this.$route.query.module_id || this.$route.query.reference) {
        this.filter.module_id = this.$route.query.module_id || ''
        this.filter.reference = this.$route.query.reference || ''
      }

      if (!this.filter.date_start && !this.filter.date_end) {
        this.filter.date_end = moment().format('YYYY-MM-DD')
        this.filter.date_start = moment().subtract(7, 'days').format('YYYY-MM-DD')
      }
    },
    mounted() {
      this.search()

      this._start = true
    },
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.search()
    },
    computed: {
      moduleOptions() {
        var seen = {}
        var options = [{ value: '', text: 'TODOS' }]

        this.table.items.forEach(item => {
          if (item.module && !seen[item.module.id]) {
            seen[item.module.id] = true
            options.push({ value: item.module.id, text: this.moduleLabel(item.module) })
          }
        });

        return options
      }
    },
    methods: {
      search() {
        let loader = this.$loading.show()

        this.saveFilterStorage()
        this.table.currentPage = 1

        serviceAPI.listNotificationsLog(this.filter)
          .then((response) => {
            loader.hide()
            // _showFullDescription se inicializa acá para que sea reactivo
            // (agregarlo después con asignación directa no dispara el render)
            this.table.items = (response.data || []).map(item => ({
              ...item,
              _showFullDescription: false,
            }))
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          })
      },
      isLongDescription(description) {
        return !!description && (description.indexOf('\n') !== -1 || description.length > 140)
      },
      toggleDescription(item) {
        item._showFullDescription = !item._showFullDescription
      },
      moduleLabel(module) {
        var label = module.title || module.name
        return label.substring(label.indexOf('.') + 1)
      },
      channelLabel(channel) {
        var labels = { internal: 'Interna', email: 'Email', sms: 'SMS', whatsapp: 'WhatsApp', push: 'Push' }
        return labels[channel] || channel
      },
      channelVariant(channel) {
        var variants = { internal: 'info', email: 'primary', sms: 'secondary', whatsapp: 'success', push: 'dark' }
        return variants[channel] || 'secondary'
      },
      deliveryStatusLabel(status) {
        var labels = { sent: 'Enviado', delivered: 'Entregado', read: 'Leído', failed: 'Falló' }
        return labels[status] || status
      },
      deliveryStatusVariant(status) {
        var variants = { sent: 'secondary', delivered: 'info', read: 'success', failed: 'danger' }
        return variants[status] || 'secondary'
      },
      clearReferenceFilter() {
        this.filter.reference = ''
        this.search()
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
      saveFilterStorage() {
        Storage.setValue('filter_view_notifications_log', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if (Storage.getValue('filter_view_notifications_log')) {
          Object.assign(this.filter, JSON.parse(Storage.getValue('filter_view_notifications_log')))
        }
      },
    }
  }
</script>
<style scoped>
.log-description {
  white-space: pre-line;
  word-break: break-word;
  max-width: 480px;
}
.log-description-collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.log-description-toggle {
  font-size: 0.8rem;
}
</style>
